function correct(text) {
  return text.replace(/'/g, '').replace(/'’/g, '').replace(/–/g, '-').replace(/–/g, '-').replace(/[\ ]{2,}/g, ' ').replace(/\n/g, '').replace(/(\&shy;|­|&#173;)/gi, '').replace(/\u00AD/g, '');
}
function correctNote(text) {
  return text.replace(/'/g, '').replace(/'’/g, '').replace(/–/g, '-');
}

function footnoteFormatter(footnote) {
  let mynode = footnote.cloneNode(true);
  const triangle = mynode.querySelector('.ns-style-triangle'),
    square = mynode.querySelector('.ns-style-square'),
    hook = mynode.querySelector('.ns-style-hook'),
    diamond = mynode.querySelector('.ns-style-diamond');
  if (triangle)
    triangle.innerHTML = '▲';

  if (square)
    square.innerHTML = '◼';

  if (diamond)
    diamond.innerHTML = '◆';

  if (hook)
    hook.innerHTML = '✓';
  let content = mynode.innerText.trim();

  return {
    richText: [
      {
        text: content.replace('\n', ' '),
        font: {
          color: { argb: 'FF707774' }
        }
      }
    ]
  };
}

const font = {
  color: {
    argb: 'FF707774'
  }
}

const fontBold = {
  bold: true,
  color: {
    argb: 'FF707774'
  }
}

const borderRegular = {
  style: 'thin',
  color: {
    argb: 'FF666666'
  }
}

const borderRegularDark = {
  style: 'medium',
  color: {
    argb: 'FF666666'
  }
}

// Define a fill for background color
const fillBackground = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'FFDEDDD9' }, // Gray color in ARGB
  bgColor: { argb: 'FFDEDDD9' }
};

const xdownloaderConfig = {
  tableSelector: ".lc-table-wrap",
  excludeTableSelector: '',
  downloadText: [
    { text: 'Save Excel' }
  ], // Text for downloadbutton, can be empty if you want to use an icon
  footnoteFormatter: footnoteFormatter,
  styles: [
    {
      class: 'head',
      font: fontBold,
      border: {
        bottom: borderRegularDark,
      },
      head: true,
      index: 10
    },
    {
      class: 'demi_bg_bline',
      font: fontBold,
      border: {
        bottom: borderRegularDark,
      }
    },
    {
      class: 'ns-horizontal-left',
      font: font,
      border: {
        bottom: borderRegular,
      }
    },
    {
      class: 'ns-horizontal-right',
      font: font,
      border: {
        bottom: borderRegular,
      }
    },
    {
      class: 'head_noline',
      font: fontBold,
      border: {
        bottom: null,
      }
    },
    {
      class: 'med_noline',
      font: fontBold,
      border: {
        bottom: null,
      }
    },
    {
      class: 'bline_bold',
      font: fontBold,
      border: {
        bottom: borderRegularDark
      },
    },
    {
      class: 'line',
      border: {
        bottom: borderRegular,
      }
    },
    {
      class: 'notes_group',
      font: fontBold
    },
    {
      class: 'line_bold',
      font: fontBold
    },
    {
      class: 'line_ind',
      font: font
    },
    {
      class: 'noline',
      font: font,
      border: {
        bottom: null,
      },
    },
    {
      class: 'noline_bold',
      font: fontBold
    },
    {
      class: 'bline',
      font: font,
      border: {
        bottom: borderRegularDark
      },
    },
    {
      class: 'srl-background-08',
      fill: fillBackground // Adding the fill to the srl-background-08 class
    },
  ], // cell Styles from classes
  // numFmt, // numFmt overwrite for custom formatting
  // mergeStrings, // Set mergeStrings for all Tables
  tableCellFormatter: function (td) {
    let cellIndex = Array.from(
      td.parentElement.children
    ).indexOf(td);

    let content = "";
    let cell = document.createElement('td');
    cell.innerHTML = td.innerHTML;


    const triangle = cell.querySelector('.triangle'),
      square = cell.querySelector('.square'),
      diamond = cell.querySelector('.diamond'),
      hook = cell.querySelector('.hook');

    if (triangle)
      triangle.innerHTML = '▲';

    if (square)
      square.innerHTML = '◼';

    if (diamond)
      diamond.innerHTML = '◆';

    if (hook)
      hook.innerHTML = '✓';

    let superscript = cell.querySelector('.superscript');
    let superscriptContent = '';
    if (superscript) {
      superscriptContent = '(' + superscript.innerText.replace(/\)/g, '').replace(/\(/g, '') + ')';
      superscript.parentNode.removeChild(superscript);
    }
    if (td.querySelector('.note__link')) {
      content = correctNote(cell.innerText.trim() + ' ' + superscriptContent);
    } else {
      content = correct(cell.innerText.trim() + ' ' + superscriptContent);

      if (square || triangle || diamond) {
        content = content.replace(/\n/g, '').replace(/\ /g, '').trim();
      }
    }

    if (cellIndex == 0 && td.classList.contains('line_ind') && content.trim() != '') {
      content = '   ' + content;
    }

    return content;
  },
};

export default xdownloaderConfig;
